import React, { useEffect, useState } from "react";
import SelectComponent from "../../shared/SelectComponent";
import { getPrograms } from "../../../services/programService";
import { getAllNamesByProgramId } from "../../../services/groupService";
import { getAllByProgramIdAndGroupName } from "../../../services/tripsService";
import { fieldStyles } from "./Responsible";
import { primary } from "../../../ui/colors";

const primaryLight = "#e0faf7";
const primaryDark = "#00a896";

const SelectTrip = ({ data, onChangeData }) => {
  const [programs, setPrograms] = useState();
  const [trips, setTrips] = useState();
  const [groups, setGroups] = useState();
  const [message, setMessage] = useState();
  const [loading, setLoading] = useState(false);

  const sortByName = (arr) =>
    [...arr].sort((a, b) => a.name?.localeCompare(b.name, "es", { sensitivity: "base" }));

  useEffect(() => {
    setMessage("");
    setLoading(true);
    getPrograms().then((res) => {
      const tripsRes = sortByName(
        res
          .filter((e) => !e.name?.includes("2025") && !e.name?.includes("2024"))
          .map((e) => ({ id: e.id, name: e.name }))
      );
      setPrograms(tripsRes);

      if (data.program) {
        getAllNamesByProgramId(data.program)
          .then((res) => {
            setGroups(renameGroups(res));
            if (data.groupName) {
              getAllByProgramIdAndGroupName(data.program, data.groupName)
                .then((res) => setTrips(renameTrips(res)))
                .finally(() => setLoading(false));
            }
          })
          .catch(console.error);
      } else {
        setLoading(false);
      }
    });
  }, []);

  const renameGroups = (res) =>
    sortByName(
      res.map((obj) => ({ ...obj, name: obj.groupName, id: obj.groupName, groupName: undefined }))
    );

  const renameTrips = (res) =>
    sortByName(
      res.map((obj) => ({
        ...obj,
        name: obj.tripName,
        id: obj.tripId,
        groupId: obj.groupId,
        groupName: undefined,
        tripName: undefined,
        tripId: undefined,
      }))
    );

  const handleChangeProgram = (val) => {
    onChangeData({ ...data, program: val.id, programName: val.name, groupName: null, trip: null, group: null });
    setMessage("");
    setLoading(true);
    getAllNamesByProgramId(val.id)
      .then((res) => setGroups(renameGroups(res)))
      .finally(() => setLoading(false));
  };

  const handleChangeGroup = (val) => {
    setLoading(true);
    onChangeData({ ...data, groupName: val.id, trip: val.id, tripName: val.name });
    getAllByProgramIdAndGroupName(data.program, val.id)
      .then((res) => setTrips(renameTrips(res)))
      .finally(() => setLoading(false));
  };

  const handleChangeTrip = (val) => {
    onChangeData({ ...data, trip: val.id, tripName: val.name, group: val.groupId });
  };

  return (
    <div style={styles.container}>
      <div style={styles.stepHeader}>
        <h2 style={styles.stepTitle}>Elegir viaje</h2>
        <p style={styles.stepSubtitle}>Seleccioná el destino, grupo y programa del viaje.</p>
      </div>

      <div style={fieldStyles.group}>
        <label style={fieldStyles.label}>Destino</label>
        <SelectComponent
          onChange={handleChangeProgram}
          label={"Elegir viaje"}
          val={data.program}
          data={programs}
          disabled={loading}
        />
      </div>

      <div style={fieldStyles.group}>
        <label style={fieldStyles.label}>Grupo</label>
        <SelectComponent
          onChange={handleChangeGroup}
          label={"Elegir grupo"}
          val={data.groupName}
          data={groups}
          disabled={loading || !data.program}
        />
      </div>

      <div style={fieldStyles.group}>
        <label style={fieldStyles.label}>Programa</label>
        <SelectComponent
          onChange={handleChangeTrip}
          label={"Elegir programa"}
          val={data.trip}
          data={trips}
          disabled={loading || !data.groupName}
        />
      </div>

      {data.trip && (
        <div style={styles.infoBox}>
          <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Comunicarse con College en caso de querer realizar modificaciones en el programa.
        </div>
      )}

      {message && <p style={{ color: "#c0392b", fontSize: 13 }}>{message}</p>}
    </div>
  );
};

export default SelectTrip;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  stepHeader: {
    marginBottom: 20,
  },
  stepTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: "#111",
    fontFamily: "Gilroy-Bold",
    marginBottom: 4,
  },
  stepSubtitle: {
    fontSize: 15,
    color: "#888",
  },
  infoBox: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    padding: "10px 14px",
    background: "#e0faf7",
    border: "1px solid #00D2B7",
    borderRadius: 8,
    fontSize: 15,
    color: "#00a896",
    marginTop: 4,
  },
};
